import InsightsFilter from "./insights-filter";

export default InsightsFilter;
